
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M127.7 130.3c.7 0 1.3.3 1.8.8s.8 1.1.8 1.8v4.3H33.6v-4.3c0-.7.3-1.3.8-1.8s1.1-.8 1.8-.8h4.3V31.9c0-1.4.5-2.7 1.5-3.7s2.2-1.5 3.7-1.5h72.5c1.4 0 2.7.5 3.7 1.5s1.5 2.2 1.5 3.7v98.4h4.3zM61.3 43.2v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6c.7 0 1.3-.3 1.8-.8s.8-1.1.8-1.8v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8-.6.4-.8 1-.8 1.8zm0 20.7v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6c.7 0 1.3-.3 1.8-.8s.8-1.1.8-1.8v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8-.6.4-.8 1.1-.8 1.8zm11.2 31.9c.7 0 1.3-.3 1.8-.8s.8-1.1.8-1.8v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6zm16.4 34.5v-18.1c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v18.1h13.8zm13.8-78.5v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6c.7 0 1.3-.3 1.8-.8.6-.5.8-1.1.8-1.8zm0 20.7v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6c.7 0 1.3-.3 1.8-.8.6-.5.8-1.1.8-1.8zm0 20.7v-8.6c0-.7-.3-1.3-.8-1.8s-1.1-.8-1.8-.8h-8.6c-.7 0-1.3.3-1.8.8s-.8 1.1-.8 1.8v8.6c0 .7.3 1.3.8 1.8s1.1.8 1.8.8h8.6c.7 0 1.3-.3 1.8-.8.6-.5.8-1.1.8-1.8z"}})])
          )
        }
      }
    